import { SymbolConstantDef, SymbolSpecificDef, SymbolVariableDef } from "@components/smart/GeneralFieldDefinition";
import { createPath, IEntity } from "@odata/BindingContext";
import {
    EntitySetName,
    EntityTypeName,
    IPrHealthInsuranceCompanyDetailEntity,
    PrHealthInsuranceCompanyDetailEntity,
    PrHealthInsuranceCompanyEntity,
    PrPayrollSettingEntity
} from "@odata/GeneratedEntityTypes";

import { BasicInputSizes, GroupedField } from "../../../enums";
import { IFormDef } from "../../../views/formView/Form";
import { IDefinition, IGetDefinition } from "../../PageUtils";
import HealthInsuranceCompanyFormView from "./HealthInsuranceCompanyFormView";

export const getDefinitions: IGetDefinition = (): IDefinition => {
    const form: IFormDef = {
        id: `${EntityTypeName.PrHealthInsuranceCompany}Form`,
        translationFiles: getDefinitions.translationFiles,
        formControl: HealthInsuranceCompanyFormView,
        fieldDefinition: {
            [createPath(PrPayrollSettingEntity.HealthInsuranceCompanies, PrHealthInsuranceCompanyDetailEntity.HealthInsuranceCompany, PrHealthInsuranceCompanyEntity.HealthInsuranceCompanyCode)]: {
                isReadOnly: true
            },
            [createPath(PrPayrollSettingEntity.HealthInsuranceCompanies, PrHealthInsuranceCompanyDetailEntity.HealthInsuranceCompany, PrHealthInsuranceCompanyEntity.ShortName)]: {
                isReadOnly: true
            },
            [createPath(PrPayrollSettingEntity.HealthInsuranceCompanies, PrHealthInsuranceCompanyDetailEntity.HealthInsuranceCompany, PrHealthInsuranceCompanyEntity.DataBoxId)]: {
                isReadOnly: true
            },
            // [createPath(PrPayrollSettingEntity.HealthInsuranceCompanies, PrHealthInsuranceCompanyDetailEntity.AccountNumber)]: {},
            [createPath(PrPayrollSettingEntity.HealthInsuranceCompanies, PrHealthInsuranceCompanyDetailEntity.SymbolVariable)]: {
                ...SymbolVariableDef,
                groupedField: GroupedField.MultiStart
            },
            [createPath(PrPayrollSettingEntity.HealthInsuranceCompanies, PrHealthInsuranceCompanyDetailEntity.SymbolSpecific)]: {
                ...SymbolSpecificDef
            },
            [createPath(PrPayrollSettingEntity.HealthInsuranceCompanies, PrHealthInsuranceCompanyDetailEntity.SymbolConstant)]: {
                ...SymbolConstantDef
            },
            [createPath(PrPayrollSettingEntity.HealthInsuranceCompanies, PrHealthInsuranceCompanyDetailEntity.RemittanceInformation)]: {
                groupedField: GroupedField.MultiEnd,
                width: BasicInputSizes.L
            }
        },
        groups: [
            {
                id: "InsuranceCompanies",
                collection: PrPayrollSettingEntity.HealthInsuranceCompanies,
                collectionOrder: createPath(PrHealthInsuranceCompanyDetailEntity.HealthInsuranceCompany, PrHealthInsuranceCompanyEntity.HealthInsuranceCompanyCode),
                showGroupDivider: true,
                isRemovable: false,
                collectionItemTitle: (index: number, item: IEntity) => {
                    const insuranceCompany = item as IPrHealthInsuranceCompanyDetailEntity;
                    return insuranceCompany.HealthInsuranceCompany.Name;
                },
                rows: [
                    [
                        { id: createPath(PrHealthInsuranceCompanyDetailEntity.HealthInsuranceCompany, PrHealthInsuranceCompanyEntity.HealthInsuranceCompanyCode) },
                        { id: createPath(PrHealthInsuranceCompanyDetailEntity.HealthInsuranceCompany, PrHealthInsuranceCompanyEntity.ShortName) },
                        { id: createPath(PrHealthInsuranceCompanyDetailEntity.HealthInsuranceCompany, PrHealthInsuranceCompanyEntity.DataBoxId) }
                        // { id: PrHealthInsuranceCompanyDetailEntity.AccountNumber },
                    ], [
                        { id: PrHealthInsuranceCompanyDetailEntity.SymbolVariable },
                        { id: PrHealthInsuranceCompanyDetailEntity.SymbolSpecific },
                        { id: PrHealthInsuranceCompanyDetailEntity.SymbolConstant },
                        { id: PrHealthInsuranceCompanyDetailEntity.RemittanceInformation }
                    ]
                ]
            }
        ]
    };

    return {
        entitySet: EntitySetName.PrPayrollSettings,
        form
    };
};

getDefinitions.translationFiles = ["HealthInsurance", "Common"];